// extracted by mini-css-extract-plugin
export default {"he":"h_he__wy5Xm","back":"h_back__TMbPz"};